import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { error, success } from './action';
import { createEpicForUseCase } from './create-epic';
export var usePromiseUseCase = function usePromiseUseCase() {
  var dispatch = useDispatch();
  return useCallback(function (name, input) {
    return new Promise(function (resolve, reject) {
      dispatch({
        type: name,
        payload: input,
        meta: {
          resolve: resolve,
          reject: reject
        }
      });
    });
  }, [dispatch]);
};
export var createPromiseUseCaseEpic = function createPromiseUseCaseEpic(useCase, name, onUnauthorized) {
  return createEpicForUseCase(useCase, name, undefined, onUnauthorized, /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(action) {
      var result, _meta, resolve, reject;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return useCase.execute(action.payload);

            case 2:
              result = _context.sent;
              _meta = action.meta, resolve = _meta.resolve, reject = _meta.reject;

              if (!result.isFailure) {
                _context.next = 7;
                break;
              }

              reject(result.error);
              return _context.abrupt("return", {
                type: "".concat(name, "_").concat(error),
                error: result,
                meta: {
                  input: action.payload
                }
              });

            case 7:
              resolve(result.getValue());
              return _context.abrupt("return", {
                type: "".concat(name, "_").concat(success),
                payload: result.getValue(),
                meta: {
                  input: action.payload
                }
              });

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }());
};